const { main } = require('./output/Main');
main();